function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__a",
  x1: 65,
  y1: -5.81,
  x2: 65,
  y2: 30.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#80e8bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d2f7e7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__d",
  x1: 65,
  y1: 67.89,
  x2: 65,
  y2: 54.21,
  xlinkHref: "#2-reduce_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__b",
  x1: 47.14,
  y1: 23.86,
  x2: 46.86,
  y2: 44.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__e",
  x1: 83.13,
  y1: 24.29,
  x2: 82.85,
  y2: 45.13,
  xlinkHref: "#2-reduce_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__c",
  x1: 65,
  y1: 32.53,
  x2: 65,
  y2: 17.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__f",
  x1: 65,
  y1: 35.21,
  x2: 65,
  y2: 54.71,
  xlinkHref: "#2-reduce_svg__c"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__g",
  x1: 21,
  y1: -5.81,
  x2: 21,
  y2: 30.04,
  xlinkHref: "#2-reduce_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__h",
  x1: 21,
  y1: 67.89,
  x2: 21,
  y2: 54.21,
  xlinkHref: "#2-reduce_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__i",
  x1: 3.14,
  y1: 23.86,
  x2: 2.86,
  y2: 44.7,
  xlinkHref: "#2-reduce_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__j",
  x1: 39.13,
  y1: 24.29,
  x2: 38.85,
  y2: 45.13,
  xlinkHref: "#2-reduce_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__k",
  x1: 21,
  y1: 32.53,
  x2: 21,
  y2: 17.59,
  xlinkHref: "#2-reduce_svg__c"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-reduce_svg__l",
  x1: 21,
  y1: 35.21,
  x2: 21,
  y2: 54.71,
  xlinkHref: "#2-reduce_svg__c"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 0h30a6 6 0 016 6v28H44V6a6 6 0 016-6z",
  fill: "url(#2-reduce_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 36h42v28a6 6 0 01-6 6H50a6 6 0 01-6-6V36z",
  fill: "url(#2-reduce_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#2-reduce_svg__b)",
  d: "M44 27h6v14h-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#2-reduce_svg__e)",
  d: "M80 27h6v14h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61 20a2 2 0 012-2h4a2 2 0 012 2v14h8V14a4 4 0 00-4-4H57a4 4 0 00-4 4v20h8z",
  fill: "url(#2-reduce_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69 50a2 2 0 01-2 2h-4a2 2 0 01-2-2V36h-8v20a4 4 0 004 4h16a4 4 0 004-4V36h-8z",
  fill: "url(#2-reduce_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 0h30a6 6 0 016 6v28H0V6a6 6 0 016-6z",
  fill: "url(#2-reduce_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 36h42v28a6 6 0 01-6 6H6a6 6 0 01-6-6V36z",
  fill: "url(#2-reduce_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#2-reduce_svg__i)",
  d: "M0 27h6v14H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#2-reduce_svg__j)",
  d: "M36 27h6v14h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 20a2 2 0 012-2h4a2 2 0 012 2v14h8V14a4 4 0 00-4-4H13a4 4 0 00-4 4v20h8z",
  fill: "url(#2-reduce_svg__k)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 50a2 2 0 01-2 2h-4a2 2 0 01-2-2V36H9v20a4 4 0 004 4h16a4 4 0 004-4V36h-8z",
  fill: "url(#2-reduce_svg__l)"
}));

function Svg2Reduce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86 70"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { Svg2Reduce as ReactComponent };